import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrashRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.1 2.4q-1.1 0-1.5 1l-.8 2.2H6A1.2 1.2 0 1 0 6 8h20a1.2 1.2 0 1 0 0-2.4h-4.8l-.8-2.2q-.4-1-1.5-1zm-6.7 8v15.2c0 1.8 1.4 3.2 3.2 3.2h12.8c1.8 0 3.2-1.4 3.2-3.2V10.4h-2.4v15.2q-.1.7-.8.8H9.6a1 1 0 0 1-.8-.8V10.4zm8 3.6a1.2 1.2 0 1 0-2.4 0v8.8a1.2 1.2 0 1 0 2.4 0zm5.6 0a1.2 1.2 0 1 0-2.4 0v8.8a1.2 1.2 0 1 0 2.4 0z" })
});
export default SvgTrashRegularIcon;
